import axios from "axios";
import Cookies from "js-cookie";
import keycloakData from "../api/apps/keycloakData";

import {
  USERSERVICE_BASE_URL,
  ARMS_BASE_URL,
  ASSESSMENT_BASE_URL,
  VLABS_BASE_URL,
  LMS_BASE_URL,
  SSO_BASE_URL,
  CTF_BASE_URL,
  CISO_BASE_URL,
  DIGITAL_NAGRIK_BASE_URL,
  CONFERENCESERVICE_BASE_URL,
  LMS_BASE_URL_NEW,
  VLABS_BASE_URL_NEW,
  AWARENESS_BASE_URL,
  SANDBOX_BASE_URL,
  DATASET_BASE_URL,
  IVP_PUBLIC_URL,
  CISO_PUBLIC_URL,
  USERSERVICE_BASE_URL_NEW,
  USERSERVICE_BASE_URL_STAGING,
  LMS_BASE_URL_LOCAL,
  LMS_BASE_URL_LOCAL_NEW,
} from "../api/apps/baseUrls";
import { get } from "lodash";

// ======================== LOCAL ===========================================
// const USERSERVICE_BASE_URL = "http://dhananjayk.hyderabad.cdac.in/backend";
// const ARMS_BASE_URL = "http://10.244.1.196:8001";
// const ASSESSMENT_BASE_URL = "http://10.244.1.115:9090";
// const VLABS_BASE_URL = "http://10.244.1.61:8080";
// const LMS_BASE_URL = "http://10.244.1.45";
// const SSO_BASE_URL = "http://10.244.0.231:8084/staysafe";
// const CTF_BASE_URL = "http://10.244.1.115:9095";
// const CISO_BASE_URL = "http://10.244.1.26:8000";
// const DIGITAL_NAGRIK_BASE_URL = "http://10.244.2.178:8084/digitalnagriks";

// ======================== STAGING ===========================================
// const USERSERVICE_BASE_URL = "https://ivpstaging.hyderabad.cdac.in/backend";
// const ARMS_BASE_URL = "https://cforms-staging.hyderabad.cdac.in/backend";
// const ASSESSMENT_BASE_URL = "https://assessment.hyderabad.cdac.in";
// const VLABS_BASE_URL = "https://ivplms-staging.hyderabad.cdac.in";
// const LMS_BASE_URL = "https://ivplms-staging.hyderabad.cdac.in";
// const SSO_BASE_URL = "https://staysafeonline.in";
// const CTF_BASE_URL = "https://ctf-ivp.hyderabad.cdac.in";
// const CISO_BASE_URL = "https://ciso.hyderabad.cdac.in/backend";

// ======================== NEW STAGING ===========================================
// const USERSERVICE_BASE_URL = "https://ivp-staging.hyderabad.cdac.in/backend";
// const ARMS_BASE_URL = "https://cforms-staging.hyderabad.cdac.in/backend";
// const ASSESSMENT_BASE_URL = "https://assessment.hyderabad.cdac.in";
// const VLABS_BASE_URL = "https://ivplms-staging.hyderabad.cdac.in";
// const LMS_BASE_URL = "https://ivplms-staging.hyderabad.cdac.in";
// const SSO_BASE_URL = "https://staysafeonline.in";
// const CTF_BASE_URL = "https://ctf-ivp.hyderabad.cdac.in";
// const CISO_BASE_URL = "https://ciso.hyderabad.cdac.in/backend";

// ======================== PRODUCTION ======================================
// const USERSERVICE_BASE_URL = "https://ivp.isea.app/backend";
// const ARMS_BASE_URL = "https://faas.isea.app/backend";
// const ASSESSMENT_BASE_URL = "https://assessment.isea.app";
// const VLABS_BASE_URL = "https://vlab.isea.app";
// const LMS_BASE_URL = "https://lms.isea.app";
// const SSO_BASE_URL = "https://staysafeonline.in";
// // const QUIZ_BASE_URL = "https://quiz.isea.app";
// const CTF_BASE_URL = "https://ctf.isea.app";
// const CISO_BASE_URL = "https://ciso.isea.app/backend";
// const DIGITAL_NAGRIK_BASE_URL = "https://dn.isea.app";

// ======================== New PRODUCTION ======================================
// const USERSERVICE_BASE_URL = "https://ivp.cdachyd.in/backend";
// const ARMS_BASE_URL = "https://raas.iseapmu.in";
// const ASSESSMENT_BASE_URL = "https://quiz.iseapmu.in";
// const VLABS_BASE_URL = "https://vlab.iseapmu.in";
// const LMS_BASE_URL = "https://lms.iseapmu.in";
// const SSO_BASE_URL = "https://staysafeonline.in";
// const CTF_BASE_URL = "https://ctf-ivp.hyderabad.cdac.in";
// // const QUIZ_BASE_URL = "https://quiz.iseapmu.in";
// const CISO_BASE_URL = "https://ciso.isea.app/backend";
// const DIGITAL_NAGRIK_BASE_URL = "https://digitalnaagrik.isea.app/";

const token = Cookies.get("ac_token");
// axios.defaults.withCredentials = true;
const authAxios = axios.create({
  headers: {
    Authorization: `Bearer ${token}`,
    // HTTP_X_API_KEY: `Bearer ${token}`,
    // 'Accept': 'application/json',
    // 'Content-Type': 'application/json'
  },
});

class Services {
  constructor() {
    // axios.defaults.withCredentials = true;
    // Other constructor logic...

    // Create an axios instance for non-authenticated requests
    this.axios = axios.create({
      baseURL: USERSERVICE_BASE_URL,
      headers: {
        "Content-Type": "application/json",
      },
    });

    // Create an axios instance for authenticated requests
    this.authAxios = axios.create({
      baseURL: USERSERVICE_BASE_URL,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    // Add a response interceptor to handle token refresh
    // this.authAxios.interceptors.response.use(
    //   (response) => response,
    //   (error) => {
    //     const originalRequest = error.config;

    //     // Check if the error is due to an expired token
    //     if (
    //       error.response &&
    //       error.response.status === 401 &&
    //       !originalRequest._retry
    //     ) {
    //       originalRequest._retry = true;

    //       // Refresh the access token
    //       return this.refreshToken().then((newToken) => {
    //         // Update the original request with the new token
    //         originalRequest.headers.Authorization = `Bearer ${newToken}`;

    //         // Retry the original request
    //         return axios(originalRequest);
    //       });
    //     }

    //     // Return any other errors
    //     return Promise.reject(error);
    //   }
    // );
  }
  // ================SSO ======================================
  keyCloak_codeGen(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/codegen", bodyjson);
  }
  keyCloak_tokenGen(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/tokengen", bodyjson);
  }
  keyCloak_logout(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/logout", bodyjson);
  }
  authorization(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/ivpauthorize", bodyjson);
  }
  getAccessToken(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/verifyUser", bodyjson);
  }
  redirectLogin(bodyjson) {
    console.log("rl");

    return axios.get(
      USERSERVICE_BASE_URL +
        `/loginRedirect?client_id=${bodyjson}&source=${bodyjson}&params={"":""}`
    );
  }
  redirectURL(bodyjson) {
    console.log("ru");
    return (
      USERSERVICE_BASE_URL +
      // `/loginRedirect?client_id=${bodyjson}&source=${bodyjson}&params={"short_code":"satyahumai"}`
      `/loginRedirect?client_id=${bodyjson}&source=${bodyjson}&params={"":""}`
    );
  }

  redirectURLWithExtraParamsValue(clientID, params) {
    console.log("rul");

    // const paramsString = encodeURIComponent(JSON.stringify(params));
    const paramsString = JSON.stringify(params);
    return (
      USERSERVICE_BASE_URL +
      `/loginRedirect?client_id=${clientID}&source=${clientID}&params=${paramsString}`
    );
  }
  validateAccessTokengenByRefreshToken(bodyjson, clientID) {
    return axios.post(
      USERSERVICE_BASE_URL + `/accessTokengen?client_id=${clientID}`,
      bodyjson
    );
  }

  sendReport(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/ISEA/sendReport/`, bodyjson);
  }

  getAllReport(bodyjson) {
    return axios.get(
      USERSERVICE_BASE_URL + `/ISEA/getIssues/?client_id=ivp`,
      bodyjson
    );
  }

  changeReportStatus(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/ISEA/resolveIssues/`, bodyjson);
  }

  // =================================== OTP Login ===================================

  mobileotpBasedLogin(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/send/sms/`, bodyjson);
  }
  loginViaMobileOtp(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/login/sms/`, bodyjson);
  }

  emailotpBasedLogin(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/send/email/`, bodyjson);
  }
  loginViaEmailOtp(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/login/email/`, bodyjson);
  }
  //    ============================= Reset Password==================================

  resetPassword(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/UpdateUserPassword",
      bodyjson
    );
  }
  generateOTPforResetPW(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + "/GenerateOTPForResetPassword",
      bodyjson
    );
  }
  verifyOTPforResetPW(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + "/VerifyOTPForResetPassword",
      bodyjson
    );
  }
  passwordReset(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/UpdateUserPassword", bodyjson);
  }

  //    ============================= Check Social Login =============================
  isSocialLoggedin(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/issociallogin", bodyjson);
  }
  //    ============================= State and District =============================
  getAllState() {
    return axios.get(USERSERVICE_BASE_URL + "/getallstate");
  }
  getDistrictByState(bodyjson) {
    const stateID = bodyjson.state_id;
    return axios.get(
      USERSERVICE_BASE_URL + `/getdistrictbystate?state=${stateID}`
    );
  }

  //    ============================= User Registration =============================

  userRegistration(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/registerup", bodyjson);
  }

  //    ============================= OTP based User Registration =============================
  email_otp_registration(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/generate-otp", bodyjson);
  }
  verify_email_otp_registartion(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/verify-otp", bodyjson);
  }
  userRegistrationByOtp(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/registerotp", bodyjson);
  }
  getCaptchaForOtpReg() {
    return axios.get(USERSERVICE_BASE_URL + "/Captcha");
  }

  //  ================================  Application Registration =======================================

  applicationRegistration(bodyjson) {
    return authAxios.post(USERSERVICE_BASE_URL + "/regApp", bodyjson);
  }
  //    ============================= Captcha =============================
  getCaptcha() {
    return axios.get(USERSERVICE_BASE_URL + "/Captcha");
  }
  getCaptchaForOtpLoginRegistration() {
    return axios.get(USERSERVICE_BASE_URL + "/ivp/register/captcha/");
  }
  getEachTotalCountForDashboard() {
    return axios.get(USERSERVICE_BASE_URL + `/dashboardCount`);
  }

  //    ============================= Logout =============================
  // userLogout(bodyjson) {
  //   return axios.post(USERSERVICE_BASE_URL + "/logout", bodyjson);
  // }
  getCaptchaNew() {
    return axios.get(USERSERVICE_BASE_URL + "/ISEA/captcha/");
  }

  sessionVerifyLogout(bodyjson) {
    return authAxios.post(USERSERVICE_BASE_URL + "/sessionVerify", bodyjson);
  }

  userLogout(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/ivplogout", bodyjson);
  }
  logoutUser(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/logout?client_id=${keycloakData.ivp_clientID}`,
      bodyjson
    );
  }
  //  ================================  User Profile =======================================
  // updateUserProfile(bodyjson) {
  //   return axios.patch(
  //     USERSERVICE_BASE_URL_NEW + "/api/createuserprofile",
  //     bodyjson
  //   );
  // }
  // getUserProfileById(bodyjson) {
  //   return axios.post(
  //     USERSERVICE_BASE_URL_NEW + "/api/createuserprofile",
  //     bodyjson
  //   );
  // }
  updateUserProfile(bodyjson) {
    return axios.patch(USERSERVICE_BASE_URL + "/Profile", bodyjson);
  }
  getUserProfileById(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/Profile", bodyjson);
  }
  getUserProfileByIdNew(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/Profile", bodyjson);
  }
  updateUserProfileNew(bodyjson) {
    return axios.patch(USERSERVICE_BASE_URL + "/Profile", bodyjson);
  }
  deleteProfileImg(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/removeImage", bodyjson);
  }
  removeInterestedTopic(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/UpdateTechnicalInterest",
      bodyjson
    );
  }

  //  ================================  User Category  =======================================

  getAllUserCategory() {
    return axios.get(USERSERVICE_BASE_URL + "/user_category");
  }

  //  ================================  Profile Picture  =======================================

  uploadProfilePic(bodyjson) {
    // bodyjson["apikey"] = process.env.SHOW_PROFILE_KEY;
    return axios.post(USERSERVICE_BASE_URL + "/profilepic", bodyjson);
  }

  //  ================================  Courses =======================================

  fetchAllDegree() {
    return axios.get(USERSERVICE_BASE_URL + "/fetchDegree");
  }
  fetchCourses(bodyjson) {
    const courseName = bodyjson.course;
    return axios.get(
      USERSERVICE_BASE_URL + `/fetchCourses?course=${courseName}`
    );
  }

  //  ================================  Institutes =======================================

  getAllInstitutes() {
    return axios.get(USERSERVICE_BASE_URL + "/AllInstitute");
  }
  instituteRegistration(bodyjson) {
    return authAxios.post(USERSERVICE_BASE_URL + "/Institute", bodyjson);
  }
  instituteType() {
    return axios.get(USERSERVICE_BASE_URL + "/institutetype");
  }
  instituteUpdate(bodyjson) {
    return authAxios.post(USERSERVICE_BASE_URL + "/InstituteUpdate", bodyjson);
  }
  updateUserDetails(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/updateUserBySuperAdmin",
      bodyjson
    );
  }

  getInstituteProfileById(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + "/getInstituteProfileById",
      bodyjson
    );
  }
  instituteUpdateById(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/UpdateInstituteProfile",
      bodyjson
    );
  }
  getInstituteGalleryById(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/GetInstituteGallary", bodyjson);
  }
  uploadGalleryImages(bodyjson) {
    return authAxios.post(USERSERVICE_BASE_URL + "/uploadImage", bodyjson);
  }
  deleteGalleryImages(bodyjson) {
    return authAxios.post(USERSERVICE_BASE_URL + "/deleteimage", bodyjson);
  }
  getThematicArea() {
    return authAxios.get(USERSERVICE_BASE_URL + "/thematicarea");
  }
  getInstituteUsersList(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/userUnderInstitute",
      bodyjson
    );
  }

  //=================================== Status of Requested application =====================================

  getRequestedApplicationStatusByIC(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/getApplicationByuserId",
      bodyjson
    );
  }
  //=================================== Request to Admin =====================================

  requestToAdmin(bodyjson) {
    return authAxios.post(USERSERVICE_BASE_URL + "/setUserInstitute", bodyjson);
  }
  //=================================== Request to institute =====================================

  requestToInstituteCoordinator(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/sendrequestforinstitute",
      bodyjson
    );
  }

  //=================================== Request Status =====================================

  approveRequestStatus(bodyjson) {
    return authAxios.put(USERSERVICE_BASE_URL + "/setPermission", bodyjson);
  }
  //=================================== User Request List for institute =====================================

  getAllUserRequestInstituteList(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/getpendinguserrequest",
      bodyjson
    );
  }
  //=================================== User Request List =====================================

  getAllUserRequestList() {
    return authAxios.get(USERSERVICE_BASE_URL + "/getPendingRequest");
  }
  //=================================== Get All Application Request List =====================================

  getAllPendingApplication() {
    return authAxios.get(USERSERVICE_BASE_URL + "/getPendingApplication");
  }
  getAllApprovedApplication() {
    return authAxios.get(USERSERVICE_BASE_URL + "/getApprovedApplication");
  }
  getAllRejectedApplication() {
    return authAxios.get(USERSERVICE_BASE_URL + "/getRejectedApplication");
  }
  //=================================== Approve Application Request  =====================================

  approveApplicationRequest(bodyjson) {
    return authAxios.post(USERSERVICE_BASE_URL + "/createClient", bodyjson);
  }

  approveUserToInstituteCoordinator(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + "/approveforinstituteuser",
      bodyjson
    );
  }

  //=================================== All Users List  =====================================

  getAllUsersByAdmin() {
    return authAxios.get(USERSERVICE_BASE_URL + "/getallivpuser");
  }
  getAllUsersWithTheirRoleByAdmin() {
    return axios.get(USERSERVICE_BASE_URL + "/getallivpuserbyrole");
  }

  getAllUsersWithTheirRoleWithPagination(bodyjson) {
    const { search, page, role, page_size } = bodyjson;

    return axios.get(
      USERSERVICE_BASE_URL +
        `/TestingUserDetails?search=${search}&page=${page}&role=${role}&page_size=${page_size}`
    );
  }
  getAlluserCount() {
    return axios.get(USERSERVICE_BASE_URL + "/userCount");
  }
  getAllUserEmailList() {
    return axios.get(USERSERVICE_BASE_URL + "/userDetailsForRoleChange");
  }

  //  ================================  User Subscribe =======================================
  subscribe(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/subscribe", bodyjson);
  }
  //  ================================  User Feedback =======================================
  userFeedback(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/userfeedback", bodyjson);
  }

  // ======================= Ref Code Gen ======================
  referralCodeGen() {
    return authAxios.post(USERSERVICE_BASE_URL + "/referralcodegen");
  }
  getReferralPointsById(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/getPointsById", bodyjson);
  }
  getTotalreferredUser(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/getTotalreferredUser", bodyjson);
  }

  //  ================================= Reward Points ==========================================
  addRewardPointsByActivity(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/reward/reward_post",
      bodyjson
    );
  }
  getRewardPointsByActivity(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/reward/totalRewardPoint",
      bodyjson
    );
  }
  // getRewardPointsByActivity(bodyjson) {
  //   return authAxios.post(USERSERVICE_BASE_URL + "/totalRewardPoint", bodyjson);
  // }
  getRewardPointsByActivityAppwise(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/reward/lastActivityByApp",
      bodyjson
    );
  }
  getAllTheLatestActivityByUser(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/lastActivityByUser",
      bodyjson
    );
  }
  getAllTheLatestActivityByUserViaKid(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/ivp/recentActivity/",
      bodyjson
    );
  }

  // ==================================== USERS RANKS ===========================================
  getUserRanksByTask(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/reward/rank", bodyjson);
  }
  getUserRanksByTaskStatus(taskID) {
    return axios.get(USERSERVICE_BASE_URL + `/reward/TaskStatus/${taskID}/`);
  }
  getUserRankRegionWise(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/reward/reward_rank`, bodyjson);
  }
  /* 
  =============================================================================================
                                  All Apllications API's
  =============================================================================================
  */
  //  ================================  User Feedback =======================================
  arms_UserCount(bodyjson) {
    return axios.get(ARMS_BASE_URL + `/ivpstaticdatabyuser/${bodyjson}/`);
  }
  quiz_UserCount(bodyjson) {
    console.log("quiz ", bodyjson);

    return axios.get(
      ASSESSMENT_BASE_URL + `/quiz-ctf/userresponse/count/${bodyjson}`
    );
  }
  ctf_UserCount(bodyjson) {
    console.log("ctf", bodyjson);

    return axios.get(
      CTF_BASE_URL +
        `/quiz-ctf/challenge-response/attended-challenge/count/${bodyjson}`
    );
  }
  vlab_UserCount(uid) {
    // return axios.post(VLABS_BASE_URL + `/ivp_vlab/admin/statistics`, bodyjson);

    return axios.post(
      // VLABS_BASE_URL + `/UpdatedSocial/statistics?unique_id=${uid}`
      VLABS_BASE_URL + `/Training/statistics?unique_id=${uid}`
    );
  }
  sso_RewardCount(bodyjson) {
    return axios.get(SSO_BASE_URL + `/userrewardscount/${bodyjson}`);
  }
  sso_Achievments(bodyjson) {
    return axios.get(SSO_BASE_URL + `/userachievements/${bodyjson}`);
  }
  sso_Achievements_Rewards(bodyjson) {
    return axios.get(SSO_BASE_URL + `/userrewardlog/${bodyjson}`);
  }
  sso_getContribution(userID) {
    return this.axios.get(SSO_BASE_URL + `/usercontributions/${userID}`);
  }
  lms_UserCount(bodyjson) {
    return axios.get(LMS_BASE_URL + `/customapi.php?email=${bodyjson}`);
  }
  ciso_UserCount(bodyjson) {
    return axios.post(CISO_BASE_URL + `/ivp_ciso_dashboard/`, bodyjson);
  }
  digital_NagrikAwarenessWebinar() {
    return axios.get(AWARENESS_BASE_URL + `/digitalnagriks/activeevents`);
  }

  // ================================== Satya Prakash=================================

  // ================================== Role Change =================================

  changeRoleBySuperAdmin(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/roleChange", bodyjson);
  }
  switchRoleBySuperAdmin(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/switchRole", bodyjson);
  }

  // ================================== Profiles =================================
  updateProfileModal(bodyjson) {
    return authAxios.post(USERSERVICE_BASE_URL + "/updateuserbyid", bodyjson);
  }

  getAllProfile(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/profile", bodyjson);
  }
  getUserCategory() {
    return axios.get(USERSERVICE_BASE_URL + "/category");
  }
  getCisoModule() {
    return axios.get(USERSERVICE_BASE_URL + "/getmodule");
  }
  getUserProfileByKeyCloakId(bodyjson) {
    // console.log("getUserProfileByKeyCloakId", bodyjson);
    // bodyjson["apikey"] = process.env.SHOW_PROFILE_KEY;
    return authAxios.post(USERSERVICE_BASE_URL + "/ivp/dashboard/", bodyjson);
  }
  updateUserProfilePersonalByKeyCloakId(bodyjson) {
    // bodyjson["apikey"] = process.env.SHOW_PROFILE_KEY;
    return authAxios.post(USERSERVICE_BASE_URL + "/updateprofile", bodyjson);
  }
  getUserProfileProfileByKeyCloakId(bodyjson) {
    return authAxios.post(USERSERVICE_BASE_URL + "/showprofile", bodyjson);
  }
  getUserProfileTechnicalByKeyCloakId(bodyjson) {
    return authAxios.post(USERSERVICE_BASE_URL + "/showtechnical", bodyjson);
  }
  updateUserProfileTechnicalByKeyCloakId(bodyjson) {
    return authAxios.post(USERSERVICE_BASE_URL + "/createtechnical", bodyjson);
  }
  deleteTechnicakSkills(bodyjson) {
    return authAxios.patch(USERSERVICE_BASE_URL + "/deleteskill", bodyjson);
  }
  getUserProfileProfessionalByKeyCloakId(bodyjson) {
    return authAxios.post(USERSERVICE_BASE_URL + "/showprofessional", bodyjson);
  }
  UpdateUserProfileProfessionalByKeyCloakId(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/createprofessional",
      bodyjson
    );
  }
  getUserProfileAcademicByKeyCloakId(bodyjson) {
    return authAxios.post(USERSERVICE_BASE_URL + "/showacademic", bodyjson);
  }
  updateUserProfileAcademicByKeyCloakId(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/createacademicprofile",
      bodyjson
    );
  }

  UpdateCisoPofile(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/createCISOprofile", bodyjson);
  }
  getCisoPofile(bodyjson) {
    return authAxios.post(USERSERVICE_BASE_URL + "/showCISOprofile", bodyjson);
  }

  getInstituteCoordinatorsLists(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/showcoordinator", bodyjson);
  }
  createInstituteCoordinators(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/createcoordinator", bodyjson);
  }
  updateInstituteCoordinators(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/updatecoordinator", bodyjson);
  }
  deleteInstituteCoordinators(bodyjson) {
    return axios.patch(USERSERVICE_BASE_URL + "/deletecoordinator", bodyjson);
  }
  getAllUserCategoryDetails() {
    return axios.get(USERSERVICE_BASE_URL + "/user_category");
  }
  //    ============================= State, District and BLocks =============================
  getAllStateIndia() {
    return axios.get(USERSERVICE_BASE_URL + "/getallstate");
  }
  getDistrictByStateIndia(bodyjson) {
    const stateID = bodyjson.state_id;
    return axios.get(
      USERSERVICE_BASE_URL + `/getdistrictbystate?state=${stateID}`
    );
  }
  getBlocksByDistrictsandState(bodyjson) {
    const stateID = bodyjson.state_id;
    const districtID = bodyjson.district_id;
    return axios.get(
      USERSERVICE_BASE_URL_STAGING +
        `/getBlock?state=${stateID}&district=${districtID}`
    );
  }
  getDepartmentDetailsByUserCategoryID(bodyjson) {
    const userCatID = bodyjson.user_catID;
    return axios.get(
      USERSERVICE_BASE_URL +
        `/getUserCategoryWiseData?user_category=${userCatID}`
    );
  }
  //    ============================= Upload Resume =============================
  uploadResume(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/resume`, bodyjson);
  }
  bulkUploadUserByIcoordinator(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + "/bulkuploadbycoordinator",
      bodyjson,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }
  getBulkUploadUserLogsByIcoordinator(bodyjson) {
    return axios.get(
      USERSERVICE_BASE_URL +
        `/invalidInstituteUser?institute=${bodyjson.instituteId}`,
      bodyjson.userID
    );
  }
  getBulkUploadFilteredUserLogsByIcoordinator(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/responseOfBulkupload`, bodyjson);
  }
  fetchAcademicCategory() {
    return axios.get(USERSERVICE_BASE_URL + "/getAcademicCategory");
  }
  bulkUploadUserByAcademicCategoryViaIcoordinator(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + "/academicDetailsBulkUpload",
      bodyjson
    );
  }
  fetchAcademicDetails() {
    return authAxios.get(USERSERVICE_BASE_URL + "/getAcademicDetails");
  }
  // ================================= Events =====================================

  getAllEvents() {
    return axios.get(USERSERVICE_BASE_URL + `/ivp/eventList/`);
  }
  getAllEventsInstituteWise(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/ivp/instituteWiseEvents/`,
      bodyjson
    );
  }
  getAllEventsByUserIdWithStatus(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/ivp/userEventList/`, bodyjson);
  }
  getAllEventsServices(bodyjson) {
    return axios.get(
      USERSERVICE_BASE_URL + `/ivp/eventServiceList/${bodyjson}/`
    );
  }
  getAllUserListWithEvents(bodyjson) {
    return axios.get(USERSERVICE_BASE_URL + `/ivp/eventUserList/${bodyjson}/`);
  }
  sendEmailNotificationToEventUsers(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/ivp/Notification/`, bodyjson);
  }
  getEmailNotificationforUser(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/ivp/getNotification/`, bodyjson);
  }

  getTotalEventsCount() {
    return axios.get(USERSERVICE_BASE_URL + `/ivp/eventCount/`);
  }
  createEvents(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/ivp/createEvent/`, bodyjson);
  }
  updateEvents(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/ivp/updateEvent/`, bodyjson);
  }

  saveCertificateNumberEvent(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/ivp/saveCertificate/`, bodyjson);
  }
  getViewEventsAllDetails(event_unicode) {
    return axios.get(
      USERSERVICE_BASE_URL + `/ivp/getAllEventData/${event_unicode}/`
    );
  }

  // Public Events API

  getAllEventsPublic() {
    return axios.get(USERSERVICE_BASE_URL + `/ISEA/allEventDetails/`);
  }

  getFeedbackBySubmissionId(bodyjson) {
    return axios.post(ARMS_BASE_URL + `/getfeedbacksubmission/`, bodyjson);
  }

  updateFeedbackStatus(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + `/ivp` + `/updateEventFeedback/`,
      bodyjson
    );
  }

  getEventPage(bodyjson) {
    // return axios.post(USERSERVICE_BASE_URL + `/ivp/?uri=${bodyjson}`);
    return axios.post(USERSERVICE_BASE_URL + `/ivp/`, bodyjson);
  }
  createUpdateEventPage(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/ivp/createEventHomePage/`,
      bodyjson
    );
  }
  changeEventUserStatus(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/ivp/addEventUser/`, bodyjson);
  }

  getEventCategoryDetails() {
    return axios.get(USERSERVICE_BASE_URL + `/ivp/event_category/`);
  }
  getEventComponents() {
    return axios.get(USERSERVICE_BASE_URL + `/getcomponent`);
  }

  getArchievedEvents() {
    return axios.get(USERSERVICE_BASE_URL + `/ivp/archievedEvents/`);
  }

  archiveEvent(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/ivp/eventArchive/`, bodyjson);
  }
  deleteEvent(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/ivp/deleteEvent/`, bodyjson);
  }

  bulkUploadUserEvents(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/ivp/addBulkUserToEvent/`,
      bodyjson
    );
  }
  getAllEventTracks(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/allEventTracking`, bodyjson);
  }

  // ================================  EVENTS MANUAL ============================================
  fetchEventManuals() {
    return axios.get(USERSERVICE_BASE_URL + `/ivp/manuals/`);
  }

  singleUploadUserEvents(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/ivp/addBulkUserToEventSingle/`,
      bodyjson
    );
  }
  // ================================  EVENTS SERVICES ============================================
  getAssessmentServices(bodyjson) {
    return axios.post(
      ASSESSMENT_BASE_URL + "/quiz-ctf/quiz/get-assessment-list",
      bodyjson
    );
  }
  getCtfServices(bodyjson) {
    return axios.post(
      CTF_BASE_URL + "/quiz-ctf/challengelist/get-ctf-list",
      bodyjson
    );
  }
  getFormsServices(bodyjson) {
    return axios.post(ARMS_BASE_URL + "/event_form_details/", bodyjson);
  }
  formEnableAutoGen(bodyjson) {
    return authAxios.post(ARMS_BASE_URL + "/autogen/", bodyjson);
  }

  createEventCategory(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/ivp/createEventCategory/`,
      bodyjson
    );
  }
  getEventParticipantCount(bodyjson) {
    return axios.get(
      USERSERVICE_BASE_URL + `/ivp/allEventParticipantCountForStatistics/`
    );
  }
  createEventCategory(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/ivp/createEventCategory/`,
      bodyjson
    );
  }

  getFaasShortCodes() {
    return axios.get(ARMS_BASE_URL + `/getFaasTemplates/`);
  }
  getConferenceUserListPaginated(query, page = 1, page_size = 20) {
    return this.axios.get(
      CONFERENCESERVICE_BASE_URL +
        `/AllUserDetails/v2/?query=${query}&page=${page}&page_size=${page_size}`
    );
  }
  addTrackLinks(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/UpdateStreamingLinks",
      body
    );
  }

  fetchCoursesByLMS() {
    const apiUrl = `${LMS_BASE_URL}/webservice/rest/server.php`;

    const params = {
      wsfunction: "core_course_get_courses",
      moodlewsrestformat: "json",
      // wstoken: "07ca0988aaecf1d0e262c69a7b47d2dc", // LOCAL ENVIRONMENT
      wstoken: "43ec19ed80019040b607c7750e3c7452", // PRODUCTION ENVIRONMENT
      // "criteria[0][key]": "id",
      // "criteria[0][value]": id.id,
    };
    const urlWithParams = `${apiUrl}?wsfunction=${params.wsfunction}&moodlewsrestformat=${params.moodlewsrestformat}&wstoken=${params.wstoken}`;
    return axios.get(urlWithParams);
  }
  updateCoursesByLMS(bodyjson) {
    const { course_id, event_unicode } = bodyjson;
    const apiUrl = `${LMS_BASE_URL}/webservice/rest/server.php`;

    const params = {
      wsfunction: "core_course_update_courses",
      moodlewsrestformat: "json",
      wstoken: "c475313cc6c1891b5f33d6c831b730a2",
      "courses[0][id]": course_id,
      "courses[0][customfields][0][shortname]": "event",
      "courses[0][customfields][0][value]": event_unicode,
    };

    return this.axios.post(apiUrl, null, { params });
  }
  mapCoursesToService(bodyjson) {
    const { course_id, event_unicode } = bodyjson;
    const service_uri = `${LMS_BASE_URL}/course/view.php?id=${course_id}`;
    const data = {
      service_uri: service_uri,
      event_unicode: event_unicode,
      course_id: course_id,
      client_id: bodyjson.client_id,
      logo: "",
      service_name: bodyjson.service_name,
    };
    return axios.post(USERSERVICE_BASE_URL + "/ivp/addEventSevice/", data);
  }

  deleteLMSService(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/ivp/deleteService/", bodyjson);
  }

  // ================================ Event GALLERY, FEEDBACk, REPOTRT ===================================
  addEventFeedbackByCoordinator(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + "/ivp/addEventPublicFeedback/",
      bodyjson
    );
  }

  getEventFeedbacksAll(event_unicode) {
    return axios.get(
      USERSERVICE_BASE_URL + `/ivp/getEventPublicFeedback/${event_unicode}/`
    );
  }

  updateEventFeedback(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/ivp/updateEventPublicFeedback/`,
      bodyjson
    );
  }

  deleteEventFeedback(bodyJson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/ivp/deleteEventPublicFeedback/`,
      bodyJson
    );
  }

  updateEventReport(bodyJson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/ivp/updateEventReport/`,
      bodyJson
    );
  }

  addEventReport(bodyJson) {
    return axios.post(USERSERVICE_BASE_URL + `/ivp/addEventReport/`, bodyJson);
  }

  deleteEventReport(bodyJson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/ivp/deleteEventReport/`,
      bodyJson
    );
  }
  getEventReportsAll(event_unicode) {
    return axios.get(
      USERSERVICE_BASE_URL + `/ivp/getEventReport/${event_unicode}/`
    );
  }

  addEventGallery(bodyJson) {
    return axios.post(USERSERVICE_BASE_URL + `/ivp/addEventGallery/`, bodyJson);
  }

  deleteEventGallery(bodyJson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/ivp/deleteEventGallery/`,
      bodyJson
    );
  }
  getEventGalleryAll(event_unicode) {
    return axios.get(
      USERSERVICE_BASE_URL + `/ivp/getEventGallery/${event_unicode}/`
    );
  }

  getIVPUserFullNameFromKeyCloakId(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/ivp/getUserDetailsFromKid/`,
      bodyjson
    );
  }
  // ================================ Event Collaborators ===================================

  getFormsCollaborators(bodyjson) {
    return authAxios.post(ARMS_BASE_URL + "/getivpcollaborators/", bodyjson);
  }
  addFormsCollaborators(bodyjson) {
    return authAxios.post(ARMS_BASE_URL + "/updateivpcollaborators/", bodyjson);
  }

  deleteFormsCollaborators(bodyjson) {
    return authAxios.post(ARMS_BASE_URL + "/deleteivpcollaborators/", bodyjson);
  }
  // ================================ Certificate By Assessment ===================================
  getUserCertificateAfterEventComplitionByAssessment(bodyjson) {
    return axios.get(
      ASSESSMENT_BASE_URL + `/quiz-ctf/userresponse/get/${bodyjson}`
    );
  }

  getUserCertificateAfterEventComplitionByAssessmentNew(bodyjson) {
    return axios.post(
      ASSESSMENT_BASE_URL + `/quiz-ctf/userresponse/get-by-email-and-eventid`,
      bodyjson
    );
  }

  getCaptchaNew() {
    return axios.get(USERSERVICE_BASE_URL + "/ISEA/captcha/");
  }

  sendReport(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/ISEA/sendReport/`, bodyjson);
  }

  getAllReport(bodyjson) {
    return axios.get(
      USERSERVICE_BASE_URL + `/ISEA/getIssues/?client_id=ivp`,
      bodyjson
    );
  }

  changeReportStatus(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/ISEA/resolveIssues/`, bodyjson);
  }

  /* 
  =============================================================================================
                                  CERTIFICATES
  =============================================================================================
  */
  getThematicClusterDetails(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/statistics`, bodyjson);
  }
  //
  getAllUserCertificatesFromAssessment(bodyjson) {
    return axios.post(
      ASSESSMENT_BASE_URL + `/quiz-ctf/userresponse/get-by-email`,
      bodyjson
    );
  }
  getAllUserCertificatesFromAwareness(bodyjson) {
    return axios.get(
      AWARENESS_BASE_URL + `/digitalnagriks/usercertificates/${bodyjson.uid}`
    );
  }

  // ================================ Keycloak Clients ===================================

  getAllKeycloakClients() {
    return authAxios.get(USERSERVICE_BASE_URL + `/getClients`);
  }
  requestToEnrollInServices(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + "/requestForService", bodyjson);
  }
  getPendingRequetsInServices(bodyjson) {
    return authAxios.get(
      USERSERVICE_BASE_URL + `/getPendingServiceRequests`,
      bodyjson
    );
  }

  getGpuForm() {
    return axios.get(USERSERVICE_BASE_URL + `/getGpuForm`);
  }

  approveServiceRequest(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/verifyPendingUserRequests`,
      bodyjson
    );
  }

  updateGPUDates(bodyjson) {
    return axios.post(USERSERVICE_BASE_URL + `/UpdateUserService`, bodyjson);
  }

  // ================================ Live Quiz ===================================

  getAllLiveQuiz() {
    return axios.get(
      ASSESSMENT_BASE_URL + `/quiz-ctf/live-quiz/active-live-quiz`
    );
  }
  // ================================ Thematic Area ===================================

  getThematicAreaLists() {
    return axios.get(USERSERVICE_BASE_URL + `/thematicarea`);
  }
  getThematicClusterLists(bodyjson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/instituteUnderThematicArea`,
      bodyjson
    );
  }
  // ================================================ PMU Activity =================================================================

  getAllTheInstituteActivityByTheirIds(bodyjson) {
    return axios.get(USERSERVICE_BASE_URL + `/getInstituteByType?${bodyjson}`);
  }

  getPmuComponentListForActivity() {
    return axios.get(USERSERVICE_BASE_URL + `/getPMUComponents`);
  }
  getEventComponentListForActivity() {
    return axios.get(USERSERVICE_BASE_URL + `/getPMUActivity`);
  }
  createInstituteActivity(bodyson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/createInstituteActivity`,
      bodyson
    );
  }
  createUpdatePMUCalender(bodyson) {
    return authAxios.post(USERSERVICE_BASE_URL + `/createPMUCalender`, bodyson);
  }
  getPMUCalender() {
    return authAxios.get(USERSERVICE_BASE_URL + `/getPMUCalender`);
  }
  deletePMUCalender(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + `/deletePMUCalender`,
      bodyjson
    );
  }
  updateInstituteActivity(bodyson) {
    return axios.post(
      USERSERVICE_BASE_URL + `/updateInstituteActivity`,
      bodyson
    );
  }
  getInstituteActivityById(bodyson) {
    return axios.post(USERSERVICE_BASE_URL + `/getInstituteActivity`, bodyson);
  }
  getInstituteActivityByAdmin() {
    return axios.get(USERSERVICE_BASE_URL + `/getAllActivity`);
  }
  getAcademicDetailsRequests() {
    return authAxios.get(USERSERVICE_BASE_URL + `/applyAcademicDetails`);
  }
  handleAcademicDetailsRequests(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + `/applyAcademicDetails`,
      bodyjson
    );
  }
  getActivityNamesList() {
    return axios.get(USERSERVICE_BASE_URL + `/getPmuActivities`);
  }
  getAllRewards(year, month, state, district, group) {
    let url = USERSERVICE_BASE_URL + "/reward/ranklist/";

    const params = new URLSearchParams();
    if (year) params.append("year", year);
    if (month) params.append("month", month);
    if (state) params.append("state", state);
    if (district) params.append("district", district);
    if (group) params.append("group", group);

    const queryString = params.toString();
    if (queryString) {
      url += "?" + queryString;
    }

    return axios.get(url);
  }

  // ==========================================================================
  //                              CONFERENCE Service Api's
  // ==========================================================================

  conferenceLogin(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/Login", body);
  }

  getConferenceUserDetails(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/UserDetails", body);
  }

  getAllUserDetails() {
    return this.axios.get(CONFERENCESERVICE_BASE_URL + "/AllUserDetails");
  }

  assignUserRole(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/AssignRole", body);
  }

  validateAccessTokengenByRefreshToken(bodyjson, clientID) {
    return this.axios.post(
      IVP_LOGIN_URL + `/accessTokengen?client_id=${clientID}`,
      bodyjson
    );
  }

  createConference(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/CreateEvent", body);
  }

  getConferenceAll() {
    return this.axios.get(CONFERENCESERVICE_BASE_URL + "/GetEventAll");
  }

  getConferenceByID(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/GetEventByID", body);
  }

  updateEvent(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/UpdateEvent", body);
  }

  createTrack(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/CreateTrack", body);
  }

  getTrackAll() {
    return this.axios.get(CONFERENCESERVICE_BASE_URL + "/GetTrackAll");
  }

  getTrackByID(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/GetTrackByID", body);
  }

  updateTrack(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/UpdateTrack", body);
  }

  getDataCounts() {
    return this.axios.get(CONFERENCESERVICE_BASE_URL + "/DataCounts");
  }

  createUserSubmission(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/CreateSubmission",
      body
    );
  }

  deleteTopic(body) {
    console.log("body", body);
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/DeleteTopic", body);
  }
  updateTopic(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/UpdateTopic", body);
  }

  updateCriteria(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/CreateCriteria",
      body
    );
  }

  addTimeSlot(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/AddTimeSlot", body);
  }
  assignReviewer(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/AssignReviewer",
      body
    );
  }

  getReviewerAll(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/GetReviewer", body);
  }

  getCriteria(shortform) {
    return this.axios.get(
      CONFERENCESERVICE_BASE_URL + `/GetCriteria/${shortform}/`
    );
  }

  deleteAssignedReviewer(body) {
    console.log("body", body);
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/DeleteReviewer",
      body
    );
  }

  getSubmissionByUser(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/ShowSubmissionByUserId",
      body
    );
  }
  getSubmissionByID(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/ShowSubmissionByID",
      body
    );
  }
  updateSubmission(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/UpdateSubmission",
      body
    );
  }

  getConferenceByReviewer(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/GetEventByReviewer",
      body
    );
  }

  getSubmissionByEventId(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/ShowSubmissionByEventId",
      body
    );
  }

  submitScore(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/SubmitScore", body);
  }

  getScore(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/GetScore", body);
  }

  changeSubmissionStatus(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/ChangeSubmissionStatus",
      body
    );
  }

  fetchTimeSlotByID(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/GetTimeSlotByEventId",
      body
    );
  }

  updateTimeslot(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/UpdateTimeSlot",
      body
    );
  }

  deleteTimeSlot(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/DeleteTimeSlot",
      body
    );
  }

  fetchUserIdByEmail(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/GetIdByEmail ", body);
  }
  fetchUserKidByEmail(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/GetKidByEmail ",
      body
    );
  }
  getRegisteredConferenceParticipants(confID) {
    console.log("confId", confID);
    return this.axios.get(
      CONFERENCESERVICE_BASE_URL + `/GetConferenceParticipants/${confID}`
    );
  }

  getRegisteredConferencesByUserId(bodyjson) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/GetConferenceByUser",
      bodyjson
    );
  }

  getConferencesByReviewer(bodyjson) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/GetEventByReviewer",
      bodyjson
    );
  }

  getConferencesByOrganiser(bodyjson) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/GetEventByOrganiser",
      bodyjson
    );
  }

  getConferencePage(conferenceId) {
    return this.axios.get(
      CONFERENCESERVICE_BASE_URL + "/GetConferencePage/" + conferenceId + "/"
    );
  }

  updateConferencePage(bodyjson) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/CreateConferencePage",
      bodyjson
    );
  }

  addConferenceSpeakers(bodyJson) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/AddConferencePresenter",
      bodyJson
    );
  }

  getSpeakers(bodyJson) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/GetSpeaker",
      bodyJson
    );
  }

  // fetchConfirmedParticipation(body) {
  //   return this.axios.post(
  //     CONFERENCESERVICE_BASE_URL + "/GetSelectedSlotBySubmissionId",
  //     body
  //   );
  // }

  confirmParticipation(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/SelectTimeSlot",
      body
    );
  }

  fetchPresentationConfirmationData(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/GetPresentationConfirmationData",
      body
    );
  }

  fetchResults(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/GetResults", body);
  }
  UpdateResult(body) {
    return this.axios.post(CONFERENCESERVICE_BASE_URL + "/DeclareResult", body);
  }

  fetchResultsBySubId(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/GetResultsBySubmissionId",
      body
    );
  }

  fetchGenericMailTemplates() {
    return this.axios.get(
      CONFERENCESERVICE_BASE_URL + "/GetGenericMailTemplates"
    );
  }

  createCustomTemplate(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + "/CreateCustomMailTemplate",
      body
    );
  }
  downloadCertificate(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + `/GetCertificate`,
      body
      // CONFERENCESERVICE_BASE_URL + `/GetCertificate/ISEASUB1TR1TO3/`
    );
  }

  getUserDataForCertificates(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + `/UserDetailsByEvent`,
      body
    );
  }
  generateCertificate(body) {
    return this.axios.post(
      CONFERENCESERVICE_BASE_URL + `/GenerateCertificate`,
      body
    );
  }
  //==============================  NEWS ==================================
  createNews(body) {
    return this.axios.post(USERSERVICE_BASE_URL + "/createNews", body);
  }
  fetchAllNews() {
    return this.axios.get(USERSERVICE_BASE_URL + "/getAllNews");
  }
  fetchNewsByUserId(body) {
    return this.axios.post(USERSERVICE_BASE_URL + "/getNewsByUser", body);
  }

  updateNews(body) {
    return this.axios.post(USERSERVICE_BASE_URL + "/updateNews", body);
  }

  fetchPublishedNews() {
    return this.axios.get(USERSERVICE_BASE_URL + "/getPublishedNews");
  }

  deleteNewsFile(body) {
    return this.axios.post(USERSERVICE_BASE_URL + "/fileDelete", body);
  }
  getNewsById(body) {
    return this.axios.post(USERSERVICE_BASE_URL + "/getNewsByID", body);
  }

  assignNewsManager(body) {
    return this.axios.post(USERSERVICE_BASE_URL + "/assignNewsManager", body);
  }

  fetchNewsManagers(body) {
    return this.axios.post(USERSERVICE_BASE_URL + "/getNewsManagers", body);
  }

  removeNewsManager(body) {
    return this.axios.post(USERSERVICE_BASE_URL + "/removeNewsManager", body);
  }

  // Public News API

  getNewsArticlesPublicApi() {
    return this.axios.get(
      USERSERVICE_BASE_URL + "/ISEA/getPublishedNewsArticles/"
    );
  }

  getNewsByIdPublicApi(id) {
    return this.axios.get(
      USERSERVICE_BASE_URL + `/ISEA/getNewsArticles/${id}/`
    );
  }

  // ================================LABS=========================================================
  getAssignedLabs(bodyjson) {
    return axios.get(
      VLABS_BASE_URL_NEW +
        // `/UpdatedSocial/IVPBookedLabs?unique_id=${bodyjson.id}`
        `/Training/IVPBookedLabs?unique_id=${bodyjson.id}`
    );
  }
  getEventWiseAssignedLabs(bodyjson) {
    return axios.post(
      VLABS_BASE_URL_NEW + `/Training/labdetails`,
      // VLABS_BASE_URL_NEW + `/UpdatedSocial/labdetails`,
      bodyjson
    );
  }

  // ================================ Statistics =========================================================

  getAllIVpCounts() {
    return axios.get(USERSERVICE_BASE_URL + `/dashboardCount`);
  }
  fetchAllEventParticipantCountForStatistics() {
    return axios.get(
      USERSERVICE_BASE_URL + `/ivp/allEventParticipantCountForStatistics/`
    );
  }
  fetchAllEventPartcipantCount() {
    return axios.get(USERSERVICE_BASE_URL + `/ISEA/allEventPartcipantCount//`);
  }

  fetchFAASAllStaticsCount() {
    return axios.get(ARMS_BASE_URL + `/staticdata`);
  }
  fetchAllVlabCount() {
    return axios.get(VLABS_BASE_URL_NEW + `/Training/labcount`);
  }
  fetchAllVlabGPUCount() {
    return axios.get(VLABS_BASE_URL_NEW + `/gpu/gpuCount`);
  }
  getGPUServiceAccessebiltyStatus() {
    return axios.get(VLABS_BASE_URL_NEW + `/gpu/gpudownaccess`);
  }
  fetchAllAssessmentCount() {
    return axios.get(
      ASSESSMENT_BASE_URL +
        `/quiz-ctf/quiz/get-totalstats-of-assessment-for-ivp`
    );
  }
  fetchAllCTFCount() {
    return axios.get(
      CTF_BASE_URL + `/quiz-ctf/challenge/get-totalstats-of-ctf`
    );
  }
  fetchAllCISOCount() {
    return axios.get(CISO_BASE_URL + `/ciso_stats_for_viewing`);
  }
  fetchAllSandboxCount() {
    return axios.get(SANDBOX_BASE_URL + `/stats/app-stats`);
  }
  fetchAllDatasetCount() {
    return axios.get(DATASET_BASE_URL + `/get-stats`);
  }

  getAllCISOTrainings(bodyjson) {
    return axios.get(USERSERVICE_BASE_URL + "/ISEA/allCisoEvents/", bodyjson);
  }

  getAllEventParticipantCount(bodyjson) {
    return axios.get(
      USERSERVICE_BASE_URL + "/ISEA/allEventPartcipantCount/",
      bodyjson
    );
  }
  getVerticalWiseStatistic() {
    return axios.get(USERSERVICE_BASE_URL + "/ivp/verticalWisEvent/");
  }
  getCisoStats(bodyjson) {
    return axios.get(CISO_BASE_URL + "/isea_ciso_stats/", bodyjson);
  }
  getallEventParticipantCountForStatistics(bodyjson) {
    return axios.get(
      USERSERVICE_BASE_URL + `/ivp/allEventParticipantCountForStatistics/`
    );
  }
  getUserWiseStatistic() {
    return axios.get(USERSERVICE_BASE_URL + "/totalusercount");
  }
  getStatPosition() {
    return axios.get(CISO_BASE_URL + "/statposition/");
  }
  getSSOStatisticsReach() {
    return axios.get(SSO_BASE_URL + "/statistics-reach");
  }
  getPledgeStats() {
    return axios.get(SSO_BASE_URL + "/pledge-stats");
  }
  getSocialStatisticsReach(bodyjson) {
    return axios.get(
      SSO_BASE_URL + `/getHandleDetails/${bodyjson?.socialname}`
    );
  }
  getQuizCTFStatisticsAwareness(bodyjson) {
    return axios.get(
      ASSESSMENT_BASE_URL + `/quiz-ctf/quiz/get-statistics-awareness`
    );
  }

  // ========================================== AWARENESS =====================================
  getAwarenessPledge() {
    return axios.get(SSO_BASE_URL + "/digitalnaagrik-mobileapi/allpledges");
  }

  // ======================================== EMAIL ===========================================

  getListofGroups() {
    return axios.get(USERSERVICE_BASE_URL + "/listofgroups/");
  }

  sendEmailToGroup(formData) {
    return axios.post(USERSERVICE_BASE_URL + `/sentmail/`, formData);
  }
  sendEmailToInstituteCo(formData) {
    return axios.post(
      USERSERVICE_BASE_URL + `/sentmailtoinstituteco/`,
      formData
    );
  }

  sendEmail(formData) {
    return axios.post(USERSERVICE_BASE_URL + `/backend/sendemail/`, formData);
  }

  // ================================ CISO EXAM ===============================================
  getEnrolledExam(bodyjson) {
    return axios.get(
      USERSERVICE_BASE_URL + `/ivp/getExam/?category=${bodyjson.catID}`
    );
  }

  enrollToExam(bodyjson) {
    return authAxios.post(
      USERSERVICE_BASE_URL + `/ivp/enrollForExam/`,
      bodyjson
    );
  }
  alreadyEnrolledExam(examId) {
    return authAxios.get(
      USERSERVICE_BASE_URL + `/ivp/enrolledExams/?exam_id=${examId}`
    );
  }
  getAllExamEnrollments() {
    return this.axios.get(USERSERVICE_BASE_URL + `/ivp/allEnrolledUsers/`);
  }

  // ================================================================================================
  fetchAllElearningEnrolledCoursesCount() {
    const apiUrl = `${LMS_BASE_URL_NEW}/webservice/rest/server.php`;
    const params = {
      wsfunction: "local_course_completed_get_completed_users",
      moodlewsrestformat: "json",
      // wstoken: "cc43a027ae719ebe89c4b9199cb4f4b1",
      wstoken: "25134b951312a0841de1fcb570d6db44",
    };
    const urlWithParams = `${apiUrl}?wsfunction=${params.wsfunction}&moodlewsrestformat=${params.moodlewsrestformat}&wstoken=${params.wstoken}`;

    return this.axios.get(urlWithParams);
  }

  // ================================Courses=========================================================

  fetchAllCourses() {
    const apiUrl = `${LMS_BASE_URL_NEW}/webservice/rest/server.php`;
    const params = {
      wsfunction: "core_course_get_courses",
      moodlewsrestformat: "json",
      wstoken: "523790472f23ef49cbd202cc71de2a71",
    };
    const urlWithParams = `${apiUrl}?wsfunction=${params.wsfunction}&moodlewsrestformat=${params.moodlewsrestformat}&wstoken=${params.wstoken}`;

    return this.axios.get(urlWithParams);
  }
  fetchCoursesByIdandValue(id) {
    const apiUrl = `${LMS_BASE_URL_NEW}/webservice/rest/server.php`;

    const params = {
      wsfunction: "core_course_get_categories",
      moodlewsrestformat: "json",
      wstoken: "09812d0f16625ceff2b42f28cf8636aa",
      "criteria[0][key]": "id",
      "criteria[0][value]": id.id,
    };
    // const urlWithParams = `${apiUrl}?wsfunction=${params.wsfunction}&moodlewsrestformat=${params.moodlewsrestformat}&wstoken=${params.wstoken}`;
    // return this.axios.post(urlWithParams);
    // return this.axios.post(apiUrl, params.toString());
    // const formattedParams = new URLSearchParams(params);
    // return this.axios.post(apiUrl + `/${formattedParams}`);
    return this.axios.post(apiUrl, null, { params });
  }
  getTotalCourses() {
    const apiUrl = `${LMS_BASE_URL_NEW}/webservice/rest/server.php`;
    const params = {
      wsfunction: "local_courses_get_courses",
      moodlewsrestformat: "json",
      wstoken: "29c210a5a16c91af126d377b564f7e2c", // PRODUCTION
      // wstoken: "3ab7a4c87d73e3f286d0420ba4dd5007", // STAGING
      courses: [],
    };
    const urlWithParams = `${apiUrl}?wsfunction=${params.wsfunction}&wstoken=${params.wstoken}&moodlewsrestformat=${params.moodlewsrestformat}&courses=[]`;

    return this.axios.post(urlWithParams);
  }
  getUsersCourses(bodyjson) {
    const apiUrl = `${LMS_BASE_URL_NEW}/webservice/rest/server.php`;
    const params = {
      wsfunction: "local_courses_get_user_courses",
      moodlewsrestformat: "json",
      wstoken: "29c210a5a16c91af126d377b564f7e2c", // PRODUCTION
      // employeeid: "03db7a6b-7662-4c69-a69d-b3db1ca72c50",
      employeeid: bodyjson?.kId,
    };
    const urlWithParams = `${apiUrl}?wsfunction=${params.wsfunction}&wstoken=${params.wstoken}&moodlewsrestformat=${params.moodlewsrestformat}&employeeid=${params.employeeid}`;

    return this.axios.post(urlWithParams);
  }
  // getUsersCourses(bodyjson) {
  //   const apiUrl = `${LMS_BASE_URL_LOCAL_NEW}/webservice/rest/server.php`;
  //   const params = {
  //     wsfunction: "local_courses_get_user_courses",
  //     moodlewsrestformat: "json",
  //     wstoken: "c58754a053c7a0574943e5ef5a5f505f", // PRODUCTION
  //     employeeid: "aa92145c-3d1e-4593-9d23-6fd5c05945b8",
  //     // employeeid: bodyjson?.kId,
  //   };
  //   const urlWithParams = `${apiUrl}?wsfunction=${params.wsfunction}&wstoken=${params.wstoken}&moodlewsrestformat=${params.moodlewsrestformat}&employeeid=${params.employeeid}`;

  //   return this.axios.post(urlWithParams);
  // }
  // getTotalCourses() {
  //   const apiUrl = `${LMS_BASE_URL_LOCAL_NEW}/webservice/rest/server.php`;
  //   const params = {
  //     wsfunction: "local_courses_get_courses",
  //     moodlewsrestformat: "json",
  //     wstoken: "c58754a053c7a0574943e5ef5a5f505f", // PRODUCTION
  //     // wstoken: "3ab7a4c87d73e3f286d0420ba4dd5007", // STAGING
  //     courses: [],
  //   };
  //   const urlWithParams = `${apiUrl}?wsfunction=${params.wsfunction}&wstoken=${params.wstoken}&moodlewsrestformat=${params.moodlewsrestformat}&courses=[]`;

  //   return this.axios.post(urlWithParams);
  // }
  getMainCourses(bodyjson) {
    const apiUrl = `${LMS_BASE_URL_LOCAL}/local/webservice/rest/server.php`;
    const params = {
      wsfunction: "local_courses_get_courses",
      moodlewsrestformat: "json",
      wstoken: "e5bc1884f07585e2cd7df55ae700c7ce", // LOCAL
      courses: [],
      // employeeid: "dc114a0c-c56b-4f42-9fa4-fcf425b1afbb",
    };
    const urlWithParams = `${apiUrl}?wsfunction=${params.wsfunction}&wstoken=${params.wstoken}&moodlewsrestformat=${params.moodlewsrestformat}&courses=[]`;

    return this.axios.post(urlWithParams);
  }
}
export default new Services();
